export default __webpack_public_path__ + "static/media/mage_identity.3290b073.mp3";